import React, { Component } from "react";
import Global from "../../Global";
import "./IDDService.css";

import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination } from "swiper";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";

SwiperCore.use([Pagination]);

class RoamingIDDService extends Component {
  constructor(props) {
    super(props);

    this.state = {
      serviceData: {},
    };
  }

  componentWillMount() {
    var url = Global.getAPI("travel-idd-services");
    var self = this;
    fetch(url)
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Error API: travel-idd-services");
        }
        return response.json();
      })
      .then(function(data) {
        self.setState({
          serviceData: data,
        });
      });
  }

  getCardHTML() {
    const data = this.state.serviceData.items;
    let html = data.map((item, index) => (
      <SwiperSlide>
        <div key={index} className="service-card">
          <a className="service-card-container" href={item.link}>
            <div className="service-card-top">
              <figure>
                <img className="img-responsive" src={item.src} alt={item.alt} />
              </figure>
            </div>
            <div className="service-card-body">
              <div className="service-content">
                <h3>{item.title}</h3>
              </div>
            </div>
            <div className="service-card-footer">
              <div className="service-card-footer-inner">
                <p>{item.description}</p>
              </div>
            </div>
          </a>
        </div>
      </SwiperSlide>
    ));

    return (
      <Swiper
        modules={[Pagination]}
        style={{
          padding: "10px 0 50px 0",
          "--swiper-pagination-color": "#ffffff",
        }}
        keyboard
        watchOverflow
        spaceBetween={20}
        slidesPerView={1}
        slidesPerColumn={1}
        breakpoints={{
          768: {
            slidesPerView: 4,
            slidesPerColumn: 1,
            spaceBetween: 30,
          },
        }}
        pagination={true}
        slidesPerColumnFill="row"
      >
        {html}
      </Swiper>
    );
  }

  render() {
    if (Object.keys(this.state.serviceData).length === 0) {
      return false;
    } else {
      return (
        <section
          id="section-roaming-service"
          className="section section-roaming-service"
        >
          <div className="container">
            <div className="section-inner">
              <div className="row">
                <div>
                  <div className="headline-logo">
                    <img
                      className="img-responsive"
                      src="assets/images/logo/logo-three-lg.png"
                      alt=""
                    />
                  </div>
                  <div className="headline">
                    <h1>{this.state.serviceData.vas.title}</h1>
                    <p>{this.state.serviceData.vas.text}</p>
                  </div>
                </div>
              </div>
              <div className="row">
                  <hr />
              </div>
              <div className="row service-card-scroller">
                {this.getCardHTML()}
              </div>
              <div className="row row-section-roaming-service-footer">
                <div className="col-xs-12">
                  <a
                    href={this.state.serviceData.vas.link}
                    id="btn-check-out-faq"
                    className="btn btn-invisible hidden-xs"
                  >
                    {this.state.serviceData.vas.label}
                  </a>
                  <a className="view-more-link visible-xs" href="#">
                    {this.state.serviceData.vas.label}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      );
    }
  }
}

export default RoamingIDDService;
